import {BrowserRouter as Router, Routes, Route, useLocation} from 'react-router-dom';
import {AppHeader} from "./components/base/AppHeader";
import {AppFooter} from "./components/base/AppFooter";
import {TermsOfService} from "./pages/TermsOfService";
import {PrivacyPolicy} from "./pages/PrivacyPolicy";
import {NotFound404} from "./pages/404NotFound";
import {HomePage} from "./pages/HomePage";

export const BOL_PRODUCT_URL = 'https://www.bol.com/nl/nl/p/peesential-plastuit-voor-vrouwen-vrouwen-urinoir-urine-fles-urinaal-herbruikbaar-plastuitje-staand-plassen-plaskoker-voor-festivals-reizen-kamperen-incl-hygienisch-tasje-extensie-roze/9300000020692334';

export const App = () => {
    return (
        <Router>
            <MyRoutes />
        </Router>
    )
};

const MyRoutes = ()=> {
    const excludeFooterPaths = useLocation().pathname === "/lolol";
    const excludedHeaderPaths = useLocation().pathname === "/lolol";

    return(
    <>
        {excludedHeaderPaths ? <></> : <AppHeader />}
        <Routes>
            <Route path="/" element={<HomePage />}/>
            <Route path="/*" element={<NotFound404/>}/>
            {/*<Route path="/terms-of-service" element={<TermsOfService />}/>*/}
            {/*<Route path="/privacy-policy" element={<PrivacyPolicy />}/>*/}
        </Routes>

        {excludeFooterPaths ? <></> : <AppFooter />}
    </>
    );
};




